// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-container {
  position: relative;
  width: 100%;
  max-width: 800px; /* Set the maximum width as needed */
}

.video-container video {
  width: 100%;
  height: auto;
}

.overlay {

  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white; /* Set the text color as needed */
  font-size: 14px; /* Set the text size as needed */
  z-index: 1;
  margin-left: -23.5em;
  margin-top: -52px;
}

/* Additional styling for lines or other elements */
.overlay p {
  /* Add styling for your text or lines */
  margin: 0;
  padding: 20px;
  /* Set background color and opacity */
}

.ant-modal-footer {
  background-color: #ffffff; /* Set your desired background color */
}
`, "",{"version":3,"sources":["webpack://./src/modules/Onboarding/Register/ProfileUpload/VideoPlayer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,MAAM;EACN,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,iCAAiC;EAC/C,eAAe,EAAE,gCAAgC;EACjD,UAAU;EACV,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE,uCAAuC;EACvC,SAAS;EACT,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;AACnE","sourcesContent":[".video-container {\n  position: relative;\n  width: 100%;\n  max-width: 800px; /* Set the maximum width as needed */\n}\n\n.video-container video {\n  width: 100%;\n  height: auto;\n}\n\n.overlay {\n\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white; /* Set the text color as needed */\n  font-size: 14px; /* Set the text size as needed */\n  z-index: 1;\n  margin-left: -23.5em;\n  margin-top: -52px;\n}\n\n/* Additional styling for lines or other elements */\n.overlay p {\n  /* Add styling for your text or lines */\n  margin: 0;\n  padding: 20px;\n  /* Set background color and opacity */\n}\n\n.ant-modal-footer {\n  background-color: #ffffff; /* Set your desired background color */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
